// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardItem.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import classnames from 'classnames';
import constants from 'logic/data/Izenda.DashboardConstants';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component }  from 'react';
import AffixContainer from 'share/components/controls/Izenda.AffixContainer';
import TextHighLight from 'share/components/controls/Izenda.TextHighLight';
import DashboardDetail from './Izenda.DashboardDetail';

const SearchCriteria = constants.SEARCH_CRITERIA;

@observer
export default class DashboardItem extends Component {
  static propTypes = {
    store: PropTypes.object
  };

  render() {
    const {
      props,
      props: { isFirstItem, isTrainingMode, isLastItem, store, subscriptionStore, subCategory, category, dashboard }
    } = this;
    const classes = classnames('panel panel-default izenda-DashboardItem', {
      'izenda-DashboardItem_last': isLastItem
    });
    const classesHeader = classnames('panel-heading text-uppercase izenda-DashboardItemHeader', {
      u_block: isFirstItem,
      u_none: isTrainingMode
    });

    return (
      <AffixContainer className={classes} affixClass='show-header' getAffix={this.getAffix}>
        <div ref={this.setRefAffix} className={classesHeader}>
          {getHeaderName()}
        </div>

        <DashboardDetail
          {...props}
          className={isFirstItem ? 'u_noMarginTop' : ''}
          store={store}
          boardDetail={dashboard}
          subCategory={subCategory}
          subscriptionStore={subscriptionStore}
        />
      </AffixContainer>
    );

    function getHeaderName() {
      if (category.isUncategorized) {
        return constants.UNCATEGORIZED;
      }

      if (subCategory.isUncategorized) {
        return (
          <TextHighLight
            highlight={store.items.searchText}
            text={category.name}
            className='text-bold'
            notHighlight={isNotHighLight(store.items.searchType, SearchCriteria[7].value)}
          />
        );
      }

      return (
        <span>
          <TextHighLight
            highlight={store.items.searchText}
            text={category.name}
            className='text-bold'
            notHighlight={isNotHighLight(store.items.searchType, SearchCriteria[7].value)}
          />
          &nbsp; -&nbsp;
          <TextHighLight
            highlight={store.items.searchText}
            text={subCategory.name}
            className='text-bold'
            notHighlight={isNotHighLight(store.items.searchType, SearchCriteria[8].value)}
          />
        </span>
      );
    }

    function isNotHighLight(searchType: string, field: any): boolean {
      return searchType !== constants.SEARCH_CRITERIA[0].value && searchType !== field;
    }
  }

  setRefAffix = (dom: HTMLDivElement): void => {
    dom && (this.affix = dom);
  };

  getAffix(): HTMLDivElement {
    return this.affix;
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardList/Izenda.DashboardItem.js